module.exports = __webpack_public_path__ + "media/smartac-overview.1c51f9a7.mp4";